import { debounce } from "lodash";
import { useState, useMemo } from "react";

export const useDebouncedPickerQuery = (timeout = 350) => {
  const [inputValue, setInputValue] = useState("");
  const [query, setQuery] = useState("");

  const debouncedSetQuery = useMemo(
    () => debounce(setQuery, timeout),
    [timeout]
  );
  const updateQuery = (query: string) => {
    debouncedSetQuery(query);
    setInputValue(query);
  };

  return {
    query,
    setQuery: updateQuery,
    inputValue,
  };
};
